import { X } from "lucide-react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../../../assets/apple-touch-icon.png";

const HeaderLogo: React.FC<{ toggleSidebar: () => void }> = ({
  toggleSidebar,
}) => {
  const merchantName = useSelector(
    (state: RootState) => state?.merchant?.profile?.merchantName
  );

  const location = useLocation();

  const isAdminRoute = location.pathname.includes("admin");

  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between p-6 border-b border-gray-200 bg-white">
      <div
        className="flex flex-col items-center gap-2 px-4 py-2 rounded-xl hover:bg-gray-50 transition-all duration-200 cursor-pointer group"
        onClick={() =>
          navigate(isAdminRoute ? "/admin/dashboard" : "/dashboard")
        }
      >
        <div className="flex-shrink-0">
          <img
            src={Logo}
            alt="logo"
            className="w-8 h-8 rounded-lg object-cover"
          />
        </div>
        <div className="flex flex-col items-center text-center">
          <span className="text-gray-900 font-semibold text-sm leading-tight capitalize">
            {merchantName}
          </span>
        </div>
      </div>

      <button
        onClick={toggleSidebar}
        className="lg:hidden p-2 text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-all duration-200"
      >
        <X size={18} />
      </button>
    </div>
  );
};

export default HeaderLogo;
